export default __webpack_public_path__ + "static/media/inside-look.5cda8b60.png";